// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"location_wrapper__3C4AB","location":"location_location__3aJXc","title":"location_title__13ptd","text":"location_text__14eHi","email":"location_email__1VGXS"};